import { render, staticRenderFns } from "./PlatformsCheckbox.vue?vue&type=template&id=e2791808"
import script from "./PlatformsCheckbox.vue?vue&type=script&lang=js"
export * from "./PlatformsCheckbox.vue?vue&type=script&lang=js"
import style0 from "./PlatformsCheckbox.vue?vue&type=style&index=0&id=e2791808&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports